import React from "react";
import "./CommonErrorPopup.css";

export default function CommonSuccessPopup({ open, message, onClose }) {
  if (!open) return null;

  return (
    <div className="common-error-backdrop" role="presentation">
      <div className="common-popup-card common-popup-card--success" role="status" aria-live="polite">
        <div className="common-popup-badge common-popup-badge--success" aria-hidden="true">
          ✓
        </div>
        <div className="common-error-message common-error-message--success">{message || "Well played. Let's keep going!"}</div>
        <button type="button" className="common-popup-button common-popup-button--success" onClick={onClose}>
          ok
        </button>
      </div>
    </div>
  );
}
